<h2 mat-dialog-title>Page {{ data.pageNumber }}: {{ data.pageTitle }}</h2>
<mat-dialog-content
  data-testid="applicability-rationale"
  [attr.data-section-id]="data.sectionId"
  [attr.data-page-number]="data.pageNumber"
  [attr.data-page-title]="data.pageTitle"
>
  <div class="rationale-section-title">
    Applicable Code:
    @if (iccUrl) {
      <a [href]="iccUrl" target="_blank" rel="noopener noreferrer" class="section-title">
        {{ data.sectionTitle }}
      </a>
    }
    @if (!iccUrl) {
      <span>{{ data.sectionTitle }}</span>
    }
  </div>
  <div
    class="rationale-hierarchy"
    data-testid="applicability-rationale-hierarchy"
    [innerHTML]="hierarchyWithLinks"
  ></div>
  <hr />
  <div class="relevance-rationale-header">
    <span class="relevance-rationale-label">Relevance Rationale</span>
    <span class="relevance-chip" [class]="'relevance-' + data.relevance.toLowerCase().replace(' ', '-')">
      {{ data.relevance }}
    </span>
  </div>
  <div class="rationale-body" data-testid="applicability-rationale-body">
    {{ data.rationale || 'No rationale provided.' }}
  </div>
  @if (data.applicabilityModel) {
    <div class="model-metadata" data-testid="applicability-rationale-provenance">
      Model: {{ data.applicabilityModel }}
      @if (data.applicabilityCreatedTime) {
        | {{ data.applicabilityCreatedTime | date: 'yyyy/MM/dd HH:mm' }}
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
